export default "__VITE_ASSET__Ch63ZNGo__"